import { render, staticRenderFns } from "./AvailabilityWeekCard.vue?vue&type=template&id=60ee0316"
import script from "./AvailabilityWeekCard.vue?vue&type=script&lang=js"
export * from "./AvailabilityWeekCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports